var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoteLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 4.125V17.125C6.5 18.0391 7.21094 18.75 8.125 18.75H16.25V14.6875C16.25 13.3672 17.3164 12.25 18.6875 12.25H22.75V4.125C22.75 3.26172 21.9883 2.5 21.125 2.5H8.125C7.21094 2.5 6.5 3.26172 6.5 4.125ZM22.6484 13.875H18.6875C18.2305 13.875 17.875 14.2812 17.875 14.6875V18.6992C18.0781 18.5977 18.2812 18.4453 18.4844 18.293L22.2422 14.5352C22.4453 14.332 22.5469 14.1289 22.6484 13.875ZM4.875 4.125C4.875 2.34766 6.29688 0.875 8.125 0.875H21.125C22.9023 0.875 24.375 2.34766 24.375 4.125V13.3672C24.375 14.2305 24.0195 15.043 23.4102 15.6523L19.6016 19.4609C18.9922 20.0703 18.1797 20.375 17.3164 20.375H8.125C6.29688 20.375 4.875 18.9531 4.875 17.125V4.125ZM16.25 24.4375C16.25 24.8945 15.8438 25.25 15.4375 25.25H6.5C2.89453 25.25 0 22.3555 0 18.75V6.5625C0 6.15625 0.355469 5.75 0.8125 5.75C1.21875 5.75 1.625 6.15625 1.625 6.5625V18.75C1.625 21.4414 3.80859 23.625 6.5 23.625H15.4375C15.8438 23.625 16.25 24.0312 16.25 24.4375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoteLarge);
export default __webpack_public_path__ + "static/media/icon_note_large.7ce918a3d39a013ac8c43c3d63b73cc5.svg";
export { ForwardRef as ReactComponent };